export default "__VITE_ASSET__DbQLwMFz__"